import { Link } from '@tanstack/react-router'
import { ArrowRight } from 'lucide-react'
import { useDashboardSummary } from '@/api/hooks'
import { Skeleton } from '@/components/ui/skeleton'
import { KpiCards } from '@/features/home/kpi-cards'
import { StatusBars } from '@/features/home/status-bars'
import { BookedBilledChart, OrdersChart, RevenueChart } from '@/features/home/trends'
import { LeadTimesCard, TopCategories, TopManufacturers } from '@/features/home/insights'

function DashboardSkeleton() {
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {Array.from({ length: 4 }).map((_, i) => (
        <Skeleton key={i} className="h-40 w-full rounded-xl" />
      ))}
      <Skeleton className="h-40 w-full rounded-xl sm:col-span-2 lg:col-span-4" />
      <Skeleton className="h-80 w-full rounded-xl sm:col-span-2 lg:col-span-4" />
    </div>
  )
}

export function DashboardPage() {
  const { data, isLoading } = useDashboardSummary()

  return (
    <div className="mx-auto max-w-7xl space-y-6">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <div className="flex items-baseline gap-3">
          <h1 className="text-2xl font-bold tracking-tight">Dashboard</h1>
          <span className="text-sm text-muted-foreground">Last 12 months</span>
        </div>
        <Link to="/analytics" className="inline-flex items-center gap-1 text-sm hover:underline">
          See analytics <ArrowRight className="h-4 w-4" />
        </Link>
      </div>

      {isLoading || !data ? (
        <DashboardSkeleton />
      ) : (
        <>
          <KpiCards summary={data} />
          <StatusBars summary={data} />
          <div className="grid gap-4 lg:grid-cols-3">
            <RevenueChart summary={data} />
            <OrdersChart summary={data} />
          </div>
          <div className="grid gap-4 lg:grid-cols-2">
            <BookedBilledChart summary={data} />
            <LeadTimesCard />
          </div>
          <div className="grid gap-4 lg:grid-cols-2">
            <TopManufacturers />
            <TopCategories />
          </div>
        </>
      )}
    </div>
  )
}
